@for (banner of banners$ | async; track banner.id) {
  <app-banner [banner]="banner" (dismiss)="onDismiss($event)" />
}
